module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel03_1280_1280_ko-42c43279064789c2b74b39f9bb8a8a43.jpg";